import React from 'react'
import { getContactPhotoURL } from '../../helpers/api'
import { useSpring, animated } from 'react-spring'

const ModalContact = props => {

    const { size, modal } = props;

    let _props = {};
    _props = useSpring({
      opacity: 1,
      marginTop: 28,
      from: { opacity: 0, marginTop: -25 },
    });

    if (!modal) {
      return null;
    }

    document.body.classList.toggle("modal-open", props.modal);

    return modal && (
        <React.Fragment>
            <div onClick={() => !modal.loading} className="modal fade show" style={{ display: 'block' }}>
                <animated.div className={`modal-dialog modal-${size || 'md'}`} style={_props}>
                    <div className="modal-content">
                        {modal.title && (
                            <div className="modal-header">
                                <h4 className="modal-title">{modal.title}</h4>
                            </div>
                        )}
                        <div className="modal-body">
                            {modal.loading && (
                                <div>
                                    <h5 className="text-center">Please wait...</h5>
                                    <div className="progress progress-info active">
                                        <div className="progress-bar progress-bar-info progress-bar-striped progress-bar-animated" style={{ width: '100%' }}></div>
                                    </div>
                                </div>
                            )}
                            {!modal.loading && (
                                <React.Fragment>
                                    <p className="text-center">
                                        <img style={{ borderRadius: '92px' }} width="92" height="92" alt={modal.data.Name} src={getContactPhotoURL(modal.data.contact_id)} />
                                    </p>
                                    <h4 className="text-center contact-name">{modal.data.Name}
                                        <br />
                                        <small>{modal.data.Title}</small>
                                    </h4>
                                    <hr />
                                    <div>
                                        {(modal.data.Notes || 'No bio available for this contact.').split("\n").map((p, idx) => p.trim().length > 0 ? (
                                            <p key={idx}>{p}</p>
                                        ) : null)}
                                    </div>
                                    {(modal.data.Website || '').trim().length ? (
                                        <p>
                                            <a href={modal.data.Website.trim()} target="_blank" rel="noopener noreferrer"><i className="fas fa-paperclip"></i> See Attached Document</a>
                                        </p>
                                    ) : null}
                                </React.Fragment>
                            )}
                        </div>
                        {modal.buttons ? (
                            <div className="modal-footer">
                                {modal.buttons.map((btn, idx) => (
                                    <button key={idx} onClick={() => btn.role === 'cancel' ? this.props.close() : (btn.onClick || null)} type="button" className={`btn btn-${btn.color || 'default'}`}>{btn.label}</button>
                                ))}
                            </div>
                        ) : !modal.loading && (
                            <div className="modal-footer">
                                <button onClick={() => { props.closeModal() }} type="button" className={`btn btn-info}`}>Close</button>
                            </div>
                        )}
                    </div>
                </animated.div>
            </div>
            <div className="modal-backdrop show"></div>
        </React.Fragment>
    )
}

export default ModalContact